import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgJhipsterModule } from 'ng-jhipster';
import { InfiniteScrollModule } from 'angular2-infinite-scroll';
import { JhiLanguageService } from 'ng-jhipster';
import { Principal} from '../shared';

@NgModule({
    imports: [
        NgbModule.forRoot(),
        NgJhipsterModule.forRoot({
            i18nEnabled: true,
            defaultI18nLang: 'fr'
        }),
        InfiniteScrollModule
    ],
    exports: [
        FormsModule,
        HttpModule,
        CommonModule,
        NgbModule,
        NgJhipsterModule,
        InfiniteScrollModule
    ]
})
export class JYoguiSharedLibsModule {
    constructor(private languageService: JhiLanguageService,
                private principal: Principal) {

        this.principal.identity().then((account) => {
            if (!account) {
                // we set the language of the browser if the user has not logged in ( is not authenticated)
                // so the app is seen in the language of the user . ie Spain, France, EEUU
                // if the user is auntheticated the language is automatically changed to the language of the user profile
                const browserLang = navigator.language ? navigator.language.split('-')[0] : '';
                const supportedLangs = ['en', 'fr', 'es'];
                const defaultLang = supportedLangs.indexOf(browserLang) >= 0 ? browserLang : 'fr';

                this.languageService.addLocation('home');
                this.languageService.changeLanguage(defaultLang);
            }
        });
  }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/shared-libs.module.ts